import React, { ReactNode } from "react";
import { Tab as HuiTab } from "@headlessui/react";
import cx from "classnames";

import Text from "../Text";
import Tag from "../Tag";
import * as s from "./styles";

interface ITabProps {
  headerText: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  fullWidth?: boolean;
  subHeader?: string;
  tagText?: string;
  tabTitleTestId?: string;
  variant?: "light" | "dark" | "green";
}

export function Tab({
  headerText,
  iconLeft,
  iconRight,
  fullWidth,
  subHeader,
  tagText,
  tabTitleTestId,
  variant = "light",
}: ITabProps) {
  return (
    <HuiTab
      className={cx(s.tabWrapper, {
        "w-full": fullWidth,
      })}
      data-testid={tabTitleTestId}
    >
      {({ selected }) => (
        <div
          className={cx(s.tabBase, {
            [s.tabActive]: selected && variant === "light",
            [s.tabInactive]: !selected && variant === "light",
            [s.tabActiveDark]: selected && variant === "dark",
            [s.tabInactiveDark]: !selected && variant === "dark",
            [s.tabActiveGreen]: selected && variant === "green",
            [s.tabInactiveGreen]: !selected && variant === "green",
            "pl-4": fullWidth,
          })}
        >
          <div className={s.headerWrapper}>
            {iconLeft && (
              <div className={cx(s.iconTagWrapper, "lg:mr-2")}>
                {iconLeft}
                {tagText && (
                  <span className={s.xsTagWrapper}>
                    <Tag variant={variant === "dark" ? "dark" : "info"}>
                      {tagText}
                    </Tag>
                  </span>
                )}
              </div>
            )}
            <Text variant="h4" color={variant === "dark" ? "white" : undefined}>
              {headerText}
            </Text>
            {iconRight && (
              <div className={cx(s.iconTagWrapper, "lg:ml-2")}>
                {iconRight}
                {tagText && (
                  <span className={s.xsTagWrapper}>
                    <Tag variant={variant === "dark" ? "dark" : "info"}>
                      {tagText}
                    </Tag>
                  </span>
                )}
              </div>
            )}
            {tagText && (
              <span className={s.lgTagWrapper}>
                <Tag variant={variant === "dark" ? "dark" : "info"}>
                  {tagText}
                </Tag>
              </span>
            )}
          </div>
          {subHeader && (
            <div className="mt-3">
              <Text
                size="sm"
                color={variant === "dark" ? "light" : "secondary"}
              >
                {subHeader}
              </Text>
            </div>
          )}
        </div>
      )}
    </HuiTab>
  );
}
